import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Invoice} from "../../../models/invoice";
import {StatusFinanceiroIntegration} from "../../../models/enums/invoice/status-financeiro-integration";
import {InvoiceUpdateProgramadoComponent} from "../../../pages/billing/invoice/invoice-update-programado/invoice-update-programado.component";
import {DialogService} from "primeng/dynamicdialog";

@Component({
  selector: 'app-financeiro-icon',
  templateUrl: './financeiro-icon.component.html',
  styleUrls: ['./financeiro-icon.component.scss']
})
export class FinanceiroIconComponent {

  @Input() invoice!: Invoice;
  @Output() updateTable = new EventEmitter();
  protected readonly StatusFinanceiroIntegration = StatusFinanceiroIntegration;

  constructor(private dialog: DialogService) {}

  async updateInvoice(): Promise<void> {
    const invoice = this.invoice;
    this.dialog.open(InvoiceUpdateProgramadoComponent, {
      width: '45%',
      height: 'auto',
      header: 'Fatura ' + this.invoice.invoiceNumber,
      data: { invoice }
    }).onClose.subscribe(() => {
      this.updateTable.emit()
    });
  }
}
